// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "somniapp/static/js/" + ({"730":"performance","778":"functions","818":"auth","851":"storage","907":"database","965":"firestore"}[chunkId] || chunkId) + "." + {"730":"d738afd3","778":"022969ae","818":"967d26bd","851":"3d85a8cf","907":"cb572e11","957":"023a18f3","965":"e8d6eef3"}[chunkId] + ".chunk.js";
};